<template>
  <div class="t-promo-code">
    <h2>{{ promo.title }}</h2>
    <form @submit.stop.prevent="Submit()">
      <div class="t-input" v-for="(item, index) in form" :key="index" :class="{_error: item.error}">
        <label>{{ item.label }}</label>
        <input v-model="item.value" :type="item.type" :placeholder="item.placeholder" @focus="Focus(index)">
      </div>
      <button class="t-btn"><span>{{ promo.btn }}</span></button>
      <vue-recaptcha class="t-recaptcha"
                     sitekey="6Lcz5IsUAAAAALnbmYv78oojYw_4qGPZzF8pi5MT"
                     v-if="errorList >= 3"
                     @verify="Verify()"></vue-recaptcha>
    </form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {store} from '../../store'

  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';

  import VueRecaptcha from 'vue-recaptcha';

  export default {
      data(){
          return{
              errorList: 0,
              verifyRecaptcha: false,

              form: [
                  {
                      label: store.getters['staticText/promo'].label,
                      name: 'promoCode',
                      type: 'text',
                      value: '',
                      placeholder: '',
                      error: false,
                      pattern: /^[a-zA-Z0-9]{1,30}$/
                  }
              ]
          }
      },
      components: { VueRecaptcha },
      computed: {
          ...mapGetters('staticText', ['promo'])
      },
      methods: {
          ...mapActions('modal', ['modalDialogClose']),
          ...mapActions('msg', ['showMsg']),
          Verify(){
              this.verifyRecaptcha = true;
          },
          Submit(){
              let is_valid = true;

              for(let i = 0; i < this.form.length; i++){
                  if(this.form[i].pattern !== '') {
                      if (!this.form[i].pattern.test(this.form[i].value)) {
                          this.form[i].error = true;
                          is_valid = false;
                      }
                  }
              }

              if(is_valid && (this.verifyRecaptcha || this.errorList < 3)){
                  let fd = new FormData();

                  for(let i = 0; i < this.form.length; i++){
                      fd.append(this.form[i].name, this.form[i].value)
                  }

                  Vue.http.post('promo', fd)
                      .then(response => {
                          if(response.body.success){
                                this.modalDialogClose();
                                this.showMsg(this.promo.msg);
                                store.dispatch('profile/LoadBalance').then(() => {});
                                store.dispatch('profile/LoadTransactions', {limit: 3}).then(() => {});
                          } else{
                              this.errorList++;

                              let text = '';
                              for(let key in response.body.errors){
                                  text += response.body.errors[key]
                              }
                              for(let i = 0; i < this.form.length; i++){
                                  this.form[i].error = true;
                              }
                              this.showMsg(text)
                          }
                      }, response => {
                          this.modalDialogClose();
                          this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                      });
              } else{
                  this.errorList++;
              }
          },
          Focus(i){
              this.form[i].error = false
          }
      }
  }
</script>

<style lang="sass">
.t-promo-code
  width: 320px
  margin: 0 auto
  background: $blue
  padding: 24px 8px 8px
  border-radius: 16px
  h2
    color: #ffffff
    margin-bottom: 24px
    text-align: center
  form
    background: #ffffff
    padding: 24px 16px 16px
    border-radius: 16px
  .t-input
    margin-bottom: 55px

.t-recaptcha
  transform: scale(0.9)
  margin-left: -14px
  margin-top: 10px
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Promo.vue